import { render, staticRenderFns } from "./Compound.vue?vue&type=template&id=a9f0db6e&scoped=true&"
import script from "./Compound.vue?vue&type=script&lang=js&"
export * from "./Compound.vue?vue&type=script&lang=js&"
import style0 from "./Compound.vue?vue&type=style&index=0&id=a9f0db6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f0db6e",
  null
  
)

export default component.exports